import { render, staticRenderFns } from "./DatosNewDiligenciaSum.vue?vue&type=template&id=0d5a0baa"
import script from "./DatosNewDiligenciaSum.vue?vue&type=script&lang=js"
export * from "./DatosNewDiligenciaSum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports